import React from "react";
import PropTypes from "prop-types";

const StyleSplitter = ({ content, indexToSplit, cssNames, className }) => {
  const contentArray = content.splitByIndex(indexToSplit);
  return (
    <div className={className || ""}>
      {contentArray.map((str, i) => (
        <span key={i} className={cssNames[i] || ""}>
          {str}
        </span>
      ))}
    </div>
  );
};

StyleSplitter.propTypes = {
  content: PropTypes.string,
  indexToSplit: PropTypes.number,
  cssNames: PropTypes.array,
  className: PropTypes.string
};

export default StyleSplitter;



// WEBPACK FOOTER //
// ./src/components/StyleSplitter/StyleSplitter.js